import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import Step2Table from './Step2Table';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { hideSidebarOnMount } from '../utils';
import { useCurrentDma } from '../hooks';

export default function Step2() {
  const navigate = useNavigate();
  hideSidebarOnMount();
  const { dma } = useCurrentDma();

  return (
    <Box>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={() => navigate(-1)}>
          <KeyboardArrowLeftIcon fontSize="large" sx={{ color: '#38414f' }} />
        </IconButton>
        <Typography variant="h1">
          <Trans i18nKey="esg:dma.step2TopicEvaluationV2.title" />
        </Typography>
      </div>
      <br />
      <Typography variant="body2" whiteSpace="pre-line">
        <Trans i18nKey="esg:dma.step2TopicEvaluationV2.subtitle" />
      </Typography>
      <br />
      {dma && <Step2Table esg_dma_id={dma.id} />}
    </Box>
  );
}
